import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    useFloating, flip, autoUpdate, offset,
} from '@floating-ui/react-dom';
import { element } from 'angular';

function Popover({
    anchorEl, open, closePopUp, children, placement = 'right',
}) {
    const {
        strategy, x, y, reference, floating, update, refs,
    } = useFloating({
        placement: placement,
        middleware: [flip(), offset({ mainAxis: 10, crossAxis: 50 })],
    });

    useEffect(() => {
        reference(anchorEl.current);
    }, [anchorEl, reference]);

    useEffect(() => {
        if (refs.reference.current && refs.floating.current && open) {
            return autoUpdate(refs.reference.current, refs.floating.current, update);
        }
        return undefined;
    }, [open, update, refs.reference, refs.floating]);

    return (
        refs.reference.current != null && open ? (
            <div
                ref={floating}
                style={{
                    position: strategy,
                    top: y ?? '',
                    left: x ?? '',
                }}
                className="upgrade-cta__pop-up border-radius-10px pad-r-16px pad-l-16px pad-b-16px height-auto"
            >
                <button
                    className="btn btn--ghost btn--close"
                    onClick={() => closePopUp()}
                    type="button"
                    aria-label='close'
                >
                    <svg
                        className="tv-icon close"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                    >
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        <path
                            d="M0 0h24v24H0z"
                            fill="none"
                        />
                    </svg>
                </button>
                {children}
            </div>
        ) : null
    );
}

export default Popover;
Popover.propTypes = {
    // eslint-disable-next-line no-undef
    anchorEl: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
    children: PropTypes.arrayOf(element),
    open: PropTypes.bool.isRequired,
    closePopUp: PropTypes.func.isRequired,
    placement: PropTypes.string,
};
